const voucherRouter = [
    {
        path: "list-voucher",
        name: "list",
        component: () => import("@/views/admin/voucher"),
        default: true,
        meta: {
            model: "voucher",
            // requiresAuth: true,
        },
    },
    {
        path: "list-voucher/add",
        name: "add",
        component: () => import("@/views/admin/voucher/function"),
        default: true,
        meta: {
            model: "voucher",
            // requiresAuth: true,
        },
    },
    {
        path: "list-voucher/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/voucher/function"),
        default: true,
        meta: {
            model: "voucher",
            // requiresAuth: true,
        },
    },
  ];
  export default voucherRouter;